import styled from "styled-components";

export const MinhasLojasPageStyle = styled.section`
  color: #282828;
  padding-top: 50px;
  margin-top: 2%;

  h1 {
    font-size: 1.5em;
    font-weight: 600;
    letter-spacing: 0.2px;
    text-align: center;
    margin-bottom: 1rem;
  }

  .btn-add-loja {
    background: rgb(131, 43, 146);
    background: linear-gradient(267deg, rgba(131, 43, 146, 1) 39%, rgba(160, 69, 176, 1) 100%);
    border: none;
    color: white;
    padding: 10px 20px;
    font-weight: 600;
    font-size: 0.9em;
    letter-spacing: 0.3px;
    border-radius: 6px;
    -webkit-box-shadow: 9px 7px 9px -5px rgb(97 96 96 / 32%);
    box-shadow: 9px 7px 9px -5px rgb(97 96 96 / 32%);
    margin-top: 20px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
  }

  .btn-add-loja:hover {
    background: rgb(160, 69, 176);
    background: linear-gradient(267deg, rgba(160, 69, 176, 1) 39%, rgba(131, 43, 146, 1) 100%);
    color: white;
  }
`;

export const LojaContainerStyle = styled.div`
  margin-left: 25%;
  margin-right: 5%;
  margin-bottom: 5%;

  @media (max-width: 2560px) {
    margin-left: 20%;
    margin-right: 5%;
  }

  @media (max-width: 1440px) {
    margin-left: 25%;
    margin-right: 5%;
  }

  @media (max-width: 1024px) {
    margin-left: 13%;
    margin-right: 5%;
  }

  @media (max-width: 770px) {
    margin-left: 15%;
    margin-right: 5%;
  }

  @media (max-width: 430px) {
    margin-left: 8%;
    margin-right: 5%;
  }
`;
